export const TEMP_UID_PREFIX = 'fe-temp';

export function generateTempUniqueId(): string {
  const idPartA = Math.random().toString(36).substring(2, 15);
  const idPartB = Math.random().toString(36).substring(2, 15);
  return `${TEMP_UID_PREFIX}-${idPartA}-${idPartB}`;
}
export const getTempNumericalId = (): number => (
  Date.now() + Math.floor(Math.random() * 1000)
);
